import omit from 'ramda/es/omit';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';

import BoolItem from 'app/components/_ui/BoolItem';


export default compose(
  branch(({ enabled }) => !enabled, renderNothing),
  mapProps(omit(['enabled']))
)(BoolItem);
